import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';

/**
 * @member [reportPlusOnesService] reportPlusOnesService
 */
var reportPlusOnesService;

/**
 * Object ReportPlusOnes service, manages Report Plus Ones Service
 * @module services/reportPlusOnesService
 * @returns [reportPlusOnesService]
 */

export default function () { // lazy initialization. we export function which returns servies. this way service will be created only when it will be really necessary

    /**
     * Assigns ReportPlusOnesModel class with properties
     * @member [ReportPlusOnes] ReportPlusOnesModel
     */
    var ReportPlusOnesModel = Model.extend({
        className: "ReportPlusOnes",
        defaults: {
        }
    });

    /**
     * Represents a collection of ReportPlusOnesModel
     * @member [ReportPlusOnes collection] ReportPlusOnesCollection
     */
    var ReportPlusOnesCollection = Collection.extend({
        model: ReportPlusOnesModel
    });

    /**
     * it's ReportPlusOnes service, object type service of the collection
     * @member [ReportPlusOnes Service] ReportPlusOnesService
     */
    var ReportPlusOnesService = ParseService.extend({
        sortBy: 'createdAt',
        model: ReportPlusOnesModel,
        collection: ReportPlusOnesCollection,
        // you can also extend any method from ParseService here
    });

    return reportPlusOnesService || (reportPlusOnesService = new ReportPlusOnesService());
};
// only created once for application
